<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'TutorLegalGroup',
})

withDefaults(defineProps<{
  title?: string
  divided?: boolean
}>(), {
  title: '',
  divided: false,
})
</script>

<template>
  <div :class="['tutor-legal-group', { 'tutor-legal-group--divided': divided }]">
    <slot name="title">
      <AppText
        v-if="title"
        name="body1-medium"
      >
        {{ title }}
      </AppText>
    </slot>
    <slot />
  </div>
</template>

<style lang="scss" scoped src="./TutorLegalGroup.scss" />
